import {runCS, sbxCoreService} from "../Network";
import {SwitchFilters} from "../Store/Filter/Types";
import PickupTypes from "../Models/PickupTypes";
import {isPresent} from "../Utils/Utils";
import env from "../Environment";
import {ShipmentsWithBillParams} from '../Store/Shipments/Types';

export const getShipments = (currentCustomer:string, status?: string) => {
  const fetchModels = [
    'pickup',
    'receiver',
    'customer_payment_type',
    'group',
    'subgroup',
    'pickup_driver',
    'delivery_driver',
    'pickup_branch.city',
    'delivery_branch.city',
    'pickup_vehicle',
    'delivery_vehicle',
    'fee',
    'customer',
    'settlement',
    'pickup_driver_consecutive',
    'pickup.paying_customer'
  ];

  const query = sbxCoreService.with('shipment')
    .andWhereIsEqualTo('pickup.paying_customer',currentCustomer);
    if(status){
      query.andWhereIsEqualTo('status',status);
    }
    return query.fetchModels(fetchModels).loadAll(fetchModels);
};

export const getShipmentsWithFilters = (currentCustomer:string, filters: SwitchFilters) => {
  const fetchModels = [
    'pickup',
    'receiver',
    'receiver.address',
    'receiver.city',
    'customer_payment_type',
    'pickup_address',
    'pickup_address.city',
    'delivery_address',
    'pickup_driver',
    'delivery_driver',
    'pickup_branch.city',
    'delivery_branch.city',
    'pickup_vehicle.driver',
    'delivery_vehicle.driver',
    'customer',
    'pickup.packing_type',
    'pickup.contact_call',
    'pickup.contact_pickup',
  ];

  const query = sbxCoreService.with('shipment')
    .andWhereIsEqualTo('customer', currentCustomer)
    .andWhereIsNotEqualTo('status', PickupTypes.CANCELADA)
    .andWhereIsNotEqualTo('status', PickupTypes.SHIPMENT_DELIVERED)

  if(isPresent(filters)) {
    query.newGroupWithAnd();
  }

  if(Boolean(filters?.shippingPickup)) {
    query.orWhereIsEqualTo('status', PickupTypes.RECOGIDA);
  }

  if(Boolean(filters?.shipmentInTransit)) {
    query.orWhereIsEqualTo('status', PickupTypes.IN_ORIGIN_WAREHOUSE)
      .orWhereIsEqualTo('status', PickupTypes.TO_DISPATCH)
      .orWhereIsEqualTo('status', PickupTypes.IN_DESTINATION_WAREHOUSE)
      .orWhereIsEqualTo('status', PickupTypes.TO_HAULAGE)
  }

  return query.fetchModels(fetchModels).loadAll(fetchModels);
};

export function getShipmentByConsecutive(consecutive: number | string) {
  return sbxCoreService.with('shipment')
    .andWhereIsNotNull('status')
    .andWhereIsNotEqualTo('status', '')
    .andWhereIsEqualTo('consecutive', consecutive).find();
}

export function getShipmentSalttoService(params:{consecutive:string}) {
  return runCS(env.CLOUD_SCRIPTS.GET_SHIPMENT_SALTTO, params);
}

export function getShipmentWithKey (params: {shipmentKey?: string, consecutive?: string | number}) {
  return runCS(env.CLOUD_SCRIPTS.GET_SHIPMENT_WITH_KEY, params);
}


export function getShipmentsWithBill(params: ShipmentsWithBillParams) {
  const toFetch = [
    "shipment.bill", "shipment.customer_payment_type", "shipment.group", "shipment.subgroup",
    "shipment.pickup_branch", "shipment.pickup_vehicle", "shipment.customer",
    "shipment.pickup_city", "shipment.delivery_city",  "shipment.customer_to_bill"
  ];

  // console.log("start: ", params.start, " end: ", params.end)

  return sbxCoreService.with("units")
    .andWhereIsEqualTo("shipment.pending", false)
    .andWhereIsEqualTo("shipment.customer", params.logged_customer_key)
    .andWhereIsNotNull('shipment.status')
    .andWhereIsNotEqualTo('shipment.status', PickupTypes.CANCELADA)
    .andWhereIsGreaterOrEqualTo("shipment.pickup_date", params.start)
    .andWhereIsLessOrEqualTo("shipment.pickup_date", params.end)
    .fetchModels(toFetch)
    .loadAll(toFetch);
}
